<template>
  <div class="language-input__container">
    <label
      id="lanuage-input"
      for="language input"
      class="language-input__label"
    >
      <p>{{ $t("LanguageInput.label.selectLanguage") }}</p>
    </label>

    <div
      class="language-input"
    >
      <DropdownSelect
        :isOpen="isOpen"
        :hasOneItemOnly="listHasOneItem"
        class="dropdown-select"
        @click="toggleSelect()"
        @onClickOutside="handleClickOutside"
      >
        <template #selectedItem>
          <template v-if="selectedSingle">
            <span
              id="dropdownSelectedItemRef"
              class="dropdown-select__selected-item"
              @keydown.enter="toggleSelect(false)"
              @keydown.space="toggleSelect(false)"
              tabindex="0"
            >
              <GlobeCircle class="dropdown-select__icon" />
              <span class="dropdown-select__selected-item__text">{{
                selectedSingle.name
              }}</span>
            </span>
          </template>
        </template>
        <template #dropdownOptions>
          <SelectList
            :items="selectList"
            :counterIndex="counterIndex"
            :isOpen="isOpen"
            id="dropdownSelectListRef"
            @click="toggleSelect()"
            @selectElement="handleLanguageChangeSelect"
            @selectElOnClick="handleLanguageChangeSelectClick"
            @moveToNextElement="goToNextEl()"
            @moveToPreviousElement="goToPreviousEl()"
            @close="toggleSelect(false)"
          >
            <template #selectItem="{ item }">
              <span class="select-list__text">{{ item?.name }}</span>
            </template>
          </SelectList>
        </template>
      </DropdownSelect>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import DropdownSelect from '@/components/ui/selects/DropdownSelect.vue';
import SelectList from '@/components/ui/selects/SelectList.vue';
import useSelectList from '@/composables/ui/useSelectList';
import { trackClarityTag, trackClarityEvent } from '@/composables/tracking/useTracking';
import {
  LOCALES,
  switchLanguage,
  getPersistedLocale,
  selectedLocale,
} from '@/packages/i18n/translation';

import GlobeCircle from '@/components/icons/GlobeCircle.vue';

const {
  isOpen,
  counterIndex,
  selectList,
  goToNextEl,
  selectEl,
  selectElOnClick,
  goToPreviousEl,
  selectedSingle,
  toggleSelect,
  listHasOneItem,
  handleClickOutside,
} = useSelectList({
  items: LOCALES,
});
const handleLanguageChangeSelect = (val) => {
  switchLanguage(val.value);
  selectEl(val);
};

const handleLanguageChangeSelectClick = (val) => {
  switchLanguage(val.value);
  selectElOnClick(val);
  trackClarityTag('language', val.value);
  trackClarityEvent('Language changed');
};

onMounted(async () => {
  const currentLocale = getPersistedLocale();
  selectElOnClick(selectedLocale());
  await switchLanguage(currentLocale);
});
</script>

<style lang="scss">
.language-input {
  position: relative;
  display: flex;
  grid-template-columns: 3fr 0.5fr;
  align-items: center;
  border-radius: $border-radius;
  background: var(--input-background);
  margin-bottom: calc($formFieldSpacing/2);
  position: relative;

  &__label p {
    margin-left: $padding-sml;
    margin-bottom: 0.5rem;
  }

  .dropdown-select {
    padding: $padding-std;
    font-size: $font-body;

    &__selected-item__text {
      font-size: $font-body;
      padding-left: $padding-std;
    }
  }
}
</style>
